import {
  CourierFilter,
  DeliveryTypeEnum,
  OrderVerticalType
} from "@saleor/types/globalTypes";

import { ERROR_FIELDS } from "./objects";

export const isOrderForAutobooking = (deliveryType: DeliveryTypeEnum) =>
  [
    DeliveryTypeEnum.EXPRESS,
    DeliveryTypeEnum.EXPRESS_LONG_DISTANCE,
    DeliveryTypeEnum.SAME_DAY
  ].includes(deliveryType);

export const isAutobookingEnabled = (
  verticalType: OrderVerticalType,
  fbAutoBookingConfigIsEnabled: boolean,
  gmAutoBookingConfigIsEnabled: boolean
) => {
  if (verticalType === OrderVerticalType.FOOD_AND_BEVERAGES) {
    return fbAutoBookingConfigIsEnabled;
  } else if (verticalType === OrderVerticalType.GENERAL_MERCHANDISE) {
    return gmAutoBookingConfigIsEnabled;
  }
  return false;
};

export const computeBookingDateTimeDifference = (booking: Date, now: Date) =>
  booking.getTime() - now.getTime();

export const isOnGoingAutobooking = (
  bookingDateTime: Date,
  createdDateTime: Date,
  nowDateTime: Date,
  bookingTaskId: string | null
) =>
  nowDateTime.getTime() >= createdDateTime.getTime() &&
  nowDateTime.getTime() < bookingDateTime.getTime() &&
  !!bookingTaskId;

export const checkErrorForMall = (field: string) =>
  [ERROR_FIELDS.MALL].includes(field);

export const expressFleetCourierChoices = [
  {
    label: `Grab Express Auto`,
    value: CourierFilter.GRAB_EXPRESS
  },
  {
    label: `Pandago Auto`,
    value: CourierFilter.PANDAGO_AUTO
  }
];
